import * as Types from '@Global/apollo/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBettingGameQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  playerIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  withStats: Types.Scalars['Boolean']['input'];
}>;


export type GetBettingGameQuery = { __typename?: 'Query', node?: { __typename?: 'Banner' } | { __typename?: 'BettingGame', id: string, name: string, rake?: number | undefined, isStarted: boolean, isCompleted: boolean, isCanceled: boolean, acceptedCurrencies: Array<Types.Currency>, betsNum?: number | undefined, nameEn: string, nameRu: string, outcomes: Array<{ __typename?: 'BettingGameOutcome', id: string, result?: number | undefined, betsNum?: number | undefined, poolSum?: { __typename?: 'Money', amount: number, currency: Types.Currency } | undefined, matches: Array<{ __typename?: 'Match', id: string, matchDay: any, score?: string | undefined, homeTeam: { __typename?: 'Team', id: string, name: string }, awayTeam: { __typename?: 'Team', id: string, name: string }, odds: Array<{ __typename?: 'MatchOdds', name: string, probability: number }>, playerStats?: Array<{ __typename?: 'PlayerStatValue', type: Types.PlayerStatValueType, value?: string | undefined, scorePerUnit?: number | undefined, totalScore?: number | undefined, teamPlayer: { __typename?: 'TeamPlayer', player: { __typename?: 'Player', id: string } } }> }>, subject: { __typename?: 'PlayerCardBettingGame', card: { __typename?: 'Card', id: string, image?: any | undefined, player: { __typename?: 'Player', name: string, id: string, avgScoreForLast5?: number | undefined, scoreByMatch: Array<{ __typename?: 'PlayerScore', matchId: string, points: number }>, teams: { __typename?: 'TeamPlayerConnection', edges: Array<{ __typename?: 'TeamPlayerEdge', node: { __typename?: 'TeamPlayer', position: Types.PlayerPosition, team: { __typename?: 'Team', id: string } } }> } } } } }>, bets: { __typename?: 'UserBetConnection', edges: Array<{ __typename?: 'UserBetEdge', node: { __typename?: 'UserBet', id: string, giftsLeft?: number | undefined, numberInGame?: number | undefined, createdAt?: any | undefined, isJackpotParticipant: boolean, account: { __typename?: 'UserAccount', id: string, name?: string | undefined }, outcome: { __typename?: 'BettingGameOutcome', id: string, subject: { __typename?: 'PlayerCardBettingGame', card: { __typename?: 'Card', id: string, image?: any | undefined, player: { __typename?: 'Player', id: string, name: string } } } }, sum: { __typename?: 'Money', amount: number, currency: Types.Currency } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | undefined, endCursor?: any | undefined } }, myBets: Array<{ __typename?: 'UserBet', id: string, outcome: { __typename?: 'BettingGameOutcome', id: string }, sum: { __typename?: 'Money', currency: Types.Currency, amount: number } }>, myGifts: Array<{ __typename?: 'CommonPack', id: string, isClaimed: boolean, expiresAt?: any | undefined, size: number } | { __typename?: 'MoneyReward', id: string, isClaimed: boolean, expiresAt?: any | undefined, rewardSum: { __typename?: 'Money', amount: number, currency: Types.Currency } } | { __typename?: 'NftCardGiveaway', id: string, isClaimed: boolean, expiresAt?: any | undefined, rewardedCard?: { __typename?: 'Card', id: string, image?: any | undefined } | undefined } | { __typename?: 'SeasonTicketReward', id: string, isClaimed: boolean, expiresAt?: any | undefined, gameFilter: { __typename?: 'GameFilter', isPaid?: boolean | undefined, isNft?: boolean | undefined, labels?: Array<string> | undefined } }>, period: { __typename?: 'DateInterval', from: any, to: any } } | { __typename?: 'Card' } | { __typename?: 'CommonPack' } | { __typename?: 'Game' } | { __typename?: 'GiftRuleForSeasonTicketReward' } | { __typename?: 'Jackpot' } | { __typename?: 'JackpotParticipant' } | { __typename?: 'LeaderboardChallenge' } | { __typename?: 'LeaderboardParticipant' } | { __typename?: 'LootBoxOffer' } | { __typename?: 'LootBoxPurchase' } | { __typename?: 'Match' } | { __typename?: 'MatchEvent' } | { __typename?: 'MoneyReward' } | { __typename?: 'NftCardGiveaway' } | { __typename?: 'Player' } | { __typename?: 'PlayerEvent' } | { __typename?: 'PlayerStatValue' } | { __typename?: 'Referee' } | { __typename?: 'Score' } | { __typename?: 'SeasonTicketReward' } | { __typename?: 'Task' } | { __typename?: 'TaskCampaign' } | { __typename?: 'Team' } | { __typename?: 'TeamPlayer' } | { __typename?: 'Tournament' } | { __typename?: 'TournamentTeam' } | { __typename?: 'UserBet' } | { __typename?: 'UserTeam' } | { __typename?: 'WalletTransaction' } | undefined };


export const GetBettingGameDocument = gql`
    query GetBettingGame($id: ID!, $after: Cursor, $playerIds: [ID!], $withStats: Boolean!) {
  node(id: $id) {
    ... on BettingGame {
      id
      name
      nameEn: name(locale: EN)
      nameRu: name(locale: RU)
      rake
      isStarted
      isCompleted
      isCanceled
      outcomes {
        id
        poolSum {
          amount
          currency
        }
        result
        betsNum
        matches {
          id
          matchDay
          score
          homeTeam {
            id
            name
          }
          awayTeam {
            id
            name
          }
          odds {
            name
            probability
          }
          playerStats(players: $playerIds) @include(if: $withStats) {
            type
            value
            scorePerUnit
            totalScore
            teamPlayer {
              player {
                id
              }
            }
          }
        }
        subject {
          ... on PlayerCardBettingGame {
            card {
              id
              image
              player {
                name
                id
                scoreByMatch {
                  matchId
                  points
                }
                teams {
                  edges {
                    node {
                      team {
                        id
                      }
                      position
                    }
                  }
                }
                avgScoreForLast5
              }
            }
          }
        }
      }
      bets(first: 20, after: $after) {
        edges {
          node {
            id
            account {
              id
              name
            }
            outcome {
              id
              subject {
                ... on PlayerCardBettingGame {
                  card {
                    id
                    image
                    player {
                      id
                      name(locale: EN)
                    }
                  }
                }
              }
            }
            sum {
              amount
              currency
            }
            giftsLeft
            numberInGame
            createdAt
            isJackpotParticipant
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
      acceptedCurrencies
      myBets {
        id
        outcome {
          id
        }
        sum {
          currency
          amount
        }
      }
      myGifts {
        ... on CommonPack {
          id
          isClaimed
          expiresAt
          size
        }
        ... on MoneyReward {
          id
          isClaimed
          expiresAt
          rewardSum {
            amount
            currency
          }
        }
        ... on NftCardGiveaway {
          id
          isClaimed
          expiresAt
          rewardedCard {
            id
            image
          }
        }
        ... on SeasonTicketReward {
          id
          isClaimed
          expiresAt
          gameFilter {
            isPaid
            isNft
            labels
          }
        }
      }
      betsNum
      period {
        from
        to
      }
    }
  }
}
    `;

/**
 * __useGetBettingGameQuery__
 *
 * To run a query within a React component, call `useGetBettingGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBettingGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBettingGameQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      playerIds: // value for 'playerIds'
 *      withStats: // value for 'withStats'
 *   },
 * });
 */
export function useGetBettingGameQuery(baseOptions: Apollo.QueryHookOptions<GetBettingGameQuery, GetBettingGameQueryVariables> & ({ variables: GetBettingGameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBettingGameQuery, GetBettingGameQueryVariables>(GetBettingGameDocument, options);
      }
export function useGetBettingGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBettingGameQuery, GetBettingGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBettingGameQuery, GetBettingGameQueryVariables>(GetBettingGameDocument, options);
        }
export function useGetBettingGameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBettingGameQuery, GetBettingGameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBettingGameQuery, GetBettingGameQueryVariables>(GetBettingGameDocument, options);
        }
export type GetBettingGameQueryHookResult = ReturnType<typeof useGetBettingGameQuery>;
export type GetBettingGameLazyQueryHookResult = ReturnType<typeof useGetBettingGameLazyQuery>;
export type GetBettingGameSuspenseQueryHookResult = ReturnType<typeof useGetBettingGameSuspenseQuery>;
export type GetBettingGameQueryResult = Apollo.QueryResult<GetBettingGameQuery, GetBettingGameQueryVariables>;